module.exports = __webpack_public_path__ + "static/img/bkCircle.d5b0e82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wheel/bkCircle.png
// module id = 0/kC
// module chunks = 0